/* eslint-disable  react/display-name */
import { Grid } from "@mui/material";
import PDialog from "../../../components/pos/PDialog";
import PText from "../../../components/pos/PText";
import MUIDataTable from "mui-datatables";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../../utils/API";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}
export default function InventoryAdjustmentHistoryView(props) {
  const { t } = useTranslation();
  const translate = t;
  const [description, setDescription] = useState(null);
  const [date, setDate] = useState(null);
  const [stockChangeType, setStockChangeType] = useState(null);
  const [orderId, setOrderId] = useState(null);
  const [mode, setMode] = useState("view");
  const [items, setItems] = useState([]);
  const [openWindow, setOpenWindow] = useState(false);

  props.biRef.inventoryAdjustmentHistoryView = {
    showinventoryAdjustmentHistoryView: showInventoryAdjustmentHistoryView,
  };

  async function showInventoryAdjustmentHistoryView(origBeanId) {
    if (origBeanId) {
      populateOrigBean(origBeanId);
    }
    setOpenWindow(true);
  }

  async function populateOrigBean(origBeanId) {
    try {
      let { data } = await API.get(
        "/api/v1/inventory/adjustment/" + origBeanId
      );
      populateData(data);
    } catch (err) {
      console.log(err);
      props.showMessage(
        "error",
        translate("Not able to retrive inventroy adjustment data from server")
      );
      setDescription(null);
      setDate(null);
      setStockChangeType(null);
      setOrderId(null);
      setItems([]);
    }
  }

  async function populateData(bean) {
    setDescription(bean.description);
    setDate(formatDate(new Date(bean.updateDate)));
    setStockChangeType(bean.stockChangeTypeString);
    setOrderId(bean.orderId);
    let data = [];
    for (let i = 0; i < bean.adjustmentItemList.length; i++) {
      let item = bean.adjustmentItemList[i];

      let adjustmentLineItem = [
        { v: i + 1 },
        { v: item.productBean.name },
        { v: item.currentQuantity },
        { v: item.updatedQuantity },
        { v: item.newQuantity },
        { v: item.reason }, //Stock change Reason
      ];
      data.push(adjustmentLineItem);
    }
    setItems(data);
  }

  function onCloseWindow() {
    setOpenWindow(false);
  }

  const columns = [
    {
      name: "serialNumber",
      label: translate("SN"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 30 }}>{value.v}</div>
        ),
      },
    },
    {
      name: "productName",
      label: translate("Product Name"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 260 }}>{value.v}</div>
        ),
      },
    },
    {
      name: "oldStock",
      label: translate("Old Stock"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 20 }}>{value.v}</div>
        ),
      },
    },
    {
      name: "changeQty",
      label: translate("Change QTY"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 20 }}>{value.v}</div>
        ),
      },
    },
    {
      name: "newStock",
      label: translate("New Stock"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 20 }}>{value.v}</div>
        ),
      },
    },
    {
      name: "reason",
      label: translate("Reason"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 20 }}>{value.v}</div>
        ),
      },
    },
  ];

  const options = {
    filterType: null,
    search: false,
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    selectableRows: "false",
    selectableRowsHeader: true,
    selectableRowsHideCheckboxes: true,
    tableBodyHeight: getWindowDimensions().height - 400,
    rowsPerPage: Math.round((getWindowDimensions().height - 400) / 50),
    rowsPerPageOptions: [
      Math.round((getWindowDimensions().height - 400) / 50),
      15,
      50,
      100,
    ],
  };

  function formatDate(date) {
    let formatted =
      date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();
    return formatted;
  }

  const content = (
    <Grid container spacing={1}>
      <Grid item xs={12} sm={6}>
        <table width="100%">
          <tbody>
            <tr>
              <td width="25%">{translate("Change Type")}</td>
              <td>
                <PText readonly value={stockChangeType}></PText>
              </td>
            </tr>
          </tbody>
        </table>
      </Grid>
      <Grid item xs={12} sm={6}>
        <table width="100%">
          <tbody>
            <tr>
              <td width="15%">{translate("Order Id")}</td>
              <td>
                <PText value={orderId}></PText>
              </td>
            </tr>
          </tbody>
        </table>
      </Grid>
      <Grid item xs={12} sm={6}>
        <table width="100%">
          <tbody>
            <tr>
              <td width="25%">{translate("Date")}</td>
              <td>
                <PText value={date}></PText>
              </td>
            </tr>
          </tbody>
        </table>
      </Grid>
      <Grid item xs={12} sm={6}>
        <table width="100%">
          <tbody>
            <tr>
              <td width="15%">{translate("Description")}</td>
              <td>
                <PText value={description}></PText>
              </td>
            </tr>
          </tbody>
        </table>
      </Grid>
      <Grid item xs={12} sm={12}>
        <MUIDataTable data={items} columns={columns} options={options} />
      </Grid>
    </Grid>
  );
  return (
    <div>
      {openWindow && (
        <PDialog
          content={content}
          title={translate("Stock Adjustment")}
          maxWidth={"lg"}
          fullWidth={true}
          open={true}
          onCloseWindow={onCloseWindow}
          mode={mode}
        ></PDialog>
      )}
    </div>
  );
}
